// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"3c222d7b","218":"d6a3eecc","488":"daacfcfc","586":"eaec6fef","593":"778a902d","662":"ca780aa4","892":"5cde83ed","906":"9b548e3a","912":"afc3df82","970":"d86d8f80","979":"e43e36b0","992":"50b0a8f7"}[chunkId] + ".chunk.js";
};